import { styled, Theme } from '@mui/material';

const itemContainerSx = ({ theme }: { theme: Theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	paddingInline: theme.spacing(2),
	// padding: theme.spacing(4),
	// background: '#f8fafc',
	// border: '1px solid #e2e8f0',
	// borderRadius: theme.spacing(2),
	marginBottom: theme.spacing(5),
	'&:last-child': {
		marginBottom: 0,
	},
});

export const SettingItemContainer = styled('div', { name: 'SettingItemContainer' })(
	itemContainerSx
);

export const SettingItemContainerForm = styled('form', { name: 'SettingItemContainerForm' })(
	itemContainerSx
);

export const SettingItemDescription = styled('div', { name: 'SettingItemDescription' })({
	flex: 1,
});

export const SettingItemControl = styled('div', { name: 'SettingItemControl' })(({ theme }) => ({
	display: 'flex',
	gap: theme.spacing(1),
	alignItems: 'center',
}));
